import cn from "classnames";
import { HStack } from "@/shared/ui/Stack";
import type { WidgetListItemValue } from "../../types";
import style from "./newVoteWidgetsListItem.module.css";

type NewVoteWidgetsListItemProps = {
    value: WidgetListItemValue;
    name: string;
    selectCount: number;
    candidateCount: number;
    onSelect: (widgetValue: WidgetListItemValue, val: boolean) => void;
};

export function NewVoteWidgetsListItem(props: NewVoteWidgetsListItemProps) {
    const disabled = props.candidateCount < 1;
    const checked = !disabled && props.candidateCount === props.selectCount;

    const wrapperStyles = cn(
        style.wrapper,
        disabled && style.disabled,
        disabled ? "disabledWidgetCheckbox" : "",
    );

    const handleSelect = () => {
        props.onSelect(props.value, !checked);
    };

    return (
        <HStack fullWidth justify="between" className={wrapperStyles}>
            <HStack justify="between">
                <input
                    id={props.value}
                    className="baseCheckbox"
                    disabled={disabled}
                    name={props.value}
                    value={props.value}
                    checked={checked}
                    type="checkbox"
                    onChange={handleSelect}
                />
                <label className={disabled ? "" : style.label} htmlFor={props.value}>
                    {props.name}
                </label>
            </HStack>
            <p className={style.count}>
                {props.selectCount} / {props.candidateCount}
            </p>
        </HStack>
    );
}
